import { localStorageEventHandler } from "src/context/UserContext";

export const redirectTo = (path) => {
  window.location.href = path;
  // window.push('/login')
};

export const logOut = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("listenerId");
  document.cookie =
    "authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/Files;";
  document.cookie =
    "authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  window.dispatchEvent(localStorageEventHandler);
};
